module.exports = __webpack_public_path__ + "static/group4_5-836bcbd8a1d2d7296fc497e1f1ba2076.webp";